// removed by extract-text-webpack-plugin
module.exports = {"container":"_2aIiu","phones":"_1MWlZ","form":"_2Q2BW","input":"_3rdgB","submitButton":"_3ul3K","instructionText":"UqG6S"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Download/index.sass
// module id = 1474
// module chunks = 1